import { Routes } from '@angular/router';
import {
  AuthGuard,
  GENERAL_CONSTANTS,
  HowdenWithoutMenuLayoutComponent,
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  NotAuthorizedComponent
} from '@howdeniberia/core-front';
import { APP_ROLES } from './../../../clients-search-lib/src/lib/core/constants/app-roles.constants';
import { SearchButtonComponent } from './features/search-clients/pages/search-button/search-button.component';
import { SearchClientsComponent } from './features/search-clients/pages/search-clients/search-clients.component';

export const AppRoutes = [
  {
    path: '',
    component: HowdenWithoutMenuLayoutComponent, //Cambiar el layout aquí si es necesario
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      isLayout: true,
      roles: [...APP_ROLES.ALL]
    },
    children: [
      {
        path: '',
        component: SearchClientsComponent,
        title: $localize`:@@app.route.search-clients:Buscador`
      },
      {
        path: 'boton',
        component: SearchButtonComponent,
        title: $localize`:@@app.route.search-clients:Botón clientes`
      }
    ]
  },
  {
    path: GENERAL_CONSTANTS.NotAuthorizedUrl,
    title: $localize`:@@app.route.notauthorized: No autorizado`,
    component: NotAuthorizedComponent
  },
  NOT_AUTHORIZED_ROUTING,
  NOT_FOUND_ROUTING,
  { path: '**', redirectTo: '404' }
] as Routes;
